import { isSearchTab } from "@client/grindex/Client/components/Search/helpers/search-tab";
import CommonSearch from "@grindex-client/components/Search/Pages/common-search.class";

function init($views: HTMLElement[]) {
	const $module = $views[0];
	const search = new CommonSearch($module);
	const searchType = $module?.dataset["type"];

	if (searchType) {
		if (isSearchTab(searchType)) {
			search.tab = searchType;
		}

		search.isApi = true;
	}

	search.search();
}

export default {
	view: "common-searchPage",
	init,
};
